import { Image, TableProps } from "antd";
import dayjs from "dayjs";
import { useAppSelector } from "../../app/store";
import AVATAR from "../../assets/images/avatar.svg";
import { dateFormat } from "../../constants/constants";
import { useGetHolidayAllowanceSalaryQuery } from "../../features/payrollSetting/payrollSettingApi";
import useError from "../../hooks/useError";
import useTable from "../../hooks/useTable";
import { ModalComponentProps } from "../../types";
import {
  GetHolidayAllowanceParamsType,
  GetVariableSalaryResponseType,
} from "../../types/payroll";
import { countParPageSerialNumber } from "../../utils/number";
import { addKeyInArray } from "../../utils/utils";
import LogList from "../common/LogList";
import CustomModal from "../ui/CustomModal";
import CustomTable from "../ui/CustomTable";
import Loader from "../ui/Loader";

type VariableSalaryType =
  GetVariableSalaryResponseType["data"]["variableSalaries"][0];

type ModalDataType = { month_year: string; business_member_id: number };

export default function HolidayAllowanceView({
  handleClose,
  data: modalData,
  ...rest
}: ModalComponentProps<ModalDataType>) {
  const { page, limit, handleLimit, handlePagination } =
    useTable<GetHolidayAllowanceParamsType>();
  const { authInfo } = useAppSelector((state) => state.auth);
  const { isLoading, isError, error, data } = useGetHolidayAllowanceSalaryQuery(
    {
      params: {
        // month_year: modalData?.month_year,
        business_member_id: modalData?.business_member_id,
        manager_id: authInfo?.role === "Manager" ? authInfo?.id : undefined,
      },
    }
  );
  useError(isError, error, "Get holiday allowance salary data fail");

  const columns: TableProps<VariableSalaryType>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "ID",
      dataIndex: "businessMember",
      render: (val) => (
        <span className="flex items-center gap-1.5 text-nowrap ">
          {val?.employee_id ?? "n/a"}
        </span>
      ),
    },
    {
      title: "Employee Name",
      dataIndex: "businessMember",
      render: (val) => (
        <div className="inline-flex items-center gap-2">
          <Image
            width={30}
            height={30}
            className="object-cover rounded-full"
            src={val?.member?.profile?.pro_pic || AVATAR}
          />
          <h6>{val?.member?.profile?.name}</h6>
        </div>
      ),
    },
    // {
    //   title: "Effective Month",
    //   dataIndex: "effective_month",

    //   render: (val) =>
    //     val ? dayjs(val, dbDateFormat).format("MMM, YYYY") : "n/a",
    // },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (val) => `${val} (Per Day)`,
    },
    {
      title: "Is Approved",
      dataIndex: "is_approved",
      align: "center",

      render: (val) => (val ? "Yes" : "No"),
    },
    {
      title: "Approved By",
      dataIndex: "approved_by_name",
      render: (val) => (val ? val?.split("-")[1] : "-"),
    },
  ];

  return (
    <CustomModal
      title="Holiday Allowance Details"
      {...rest}
      handleClose={handleClose}
      width={900}
      footer={null}
    >
      <CustomTable
        loading={isLoading}
        page={page}
        limit={limit}
        columns={columns}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        dataSource={addKeyInArray(data?.data.holidayAllowanceExcel)}
        total={data?.data.totalHolidayAllowanceExcel}
      />

      {isLoading ? (
        <Loader />
      ) : (
        <LogList
          className="mt-6"
          list={data?.data?.holidayAllowanceExcelLogs?.map((item) => ({
            id: item?.id,
            date: dayjs(item?.created_at)?.format(dateFormat),
            log: item?.log,
          }))}
        />
      )}
    </CustomModal>
  );
}
